import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconMappingOff(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.59279 7.30485L8.59217 7.30221L8.67814 7.39295L20.218 19.3051C20.6023 19.7017 20.5922 20.3348 20.1955 20.7191C19.8141 21.0886 19.2141 21.0935 18.8269 20.7407C18.4177 20.9084 17.9696 21.0009 17.5 21.0009C15.567 21.0009 14 19.4339 14 17.5009C14 16.9927 14.1084 16.5097 14.3032 16.0739L11.3263 13.0009L8.50001 13.0009C7.94773 13.0009 7.50001 13.4486 7.50001 14.0009L7.50001 14.1458C8.94576 14.5761 10 15.9154 10 17.5009C10 19.4339 8.43301 21.0009 6.50002 21.0009C4.56702 21.0009 3.00001 19.4339 3.00001 17.5009C3.00001 15.9154 4.05427 14.5761 5.50001 14.1458L5.50001 14.0009C5.50001 12.3441 6.84316 11.0009 8.50001 11.0009L9.38876 11.0009L3.28151 4.69665C2.89724 4.29998 2.90728 3.6669 3.30396 3.28262C3.70063 2.89834 4.33372 2.90839 4.71799 3.30506L8.59279 7.30485ZM5.00001 17.5009C5.00001 16.6725 5.67159 16.0009 6.50001 16.0009C7.32844 16.0009 8.00001 16.6725 8.00001 17.5009C8.00001 18.3293 7.32844 19.0009 6.50001 19.0009C5.67159 19.0009 5.00001 18.3293 5.00001 17.5009Z"
        fill="currentColor"
      />
      <path
        d="M10.5027 6.4108L8.95389 4.77597C9.55541 3.71602 10.6942 3.00091 12 3.00091C13.933 3.00091 15.5 4.56792 15.5 6.50091C15.5 7.87416 14.7091 9.0627 13.558 9.63588L12.0091 8.00088C12.8333 7.99601 13.5 7.32632 13.5 6.50091C13.5 5.67248 12.8284 5.00091 12 5.00091C11.2018 5.00091 10.5493 5.62433 10.5027 6.4108Z"
        fill="currentColor"
      />
      <path
        d="M14.8512 11.0009L21 17.4913C20.9958 15.91 19.9428 14.5753 18.5 14.1459L18.5 14.0009C18.5 12.3441 17.1569 11.0009 15.5 11.0009L14.8512 11.0009Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
